module.exports = __webpack_public_path__ + "img/terraform.1224a469.png";